import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'
import { ConvertedComponentData, TextInput } from '../../types'

@Injectable({ providedIn: 'root' })
export class FreshchatWebWidgetConverter extends CmsConverterService<FreshchatWebWidgetData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      widgetUuid: formData.st_widget_uuid ?? defaultTextInput,
      host: formData.st_host ?? defaultTextInput,
      token: formData.st_token ?? defaultTextInput,
    }
  }
}

export const FRESHCHAT_WEB_WIDGET_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, FreshchatWebWidgetData>>('FreshchatWebWidgetConverter')

export interface FreshchatWebWidgetData extends ConvertedComponentData {
  widgetUuid: TextInput;
  host: TextInput;
  token: TextInput;
}
